<template>
    <div>
        <Head :title="__('Dashboard')" />
  
        <div class="flex flex-col gap-3 mb-4 md:flex-row w-full items-center ticket-filters">
              <div class="mr-2 w-full">{{ __('Filtrar por') }}:</div>
  
             
              <text-input type="date" v-model="form.fini" :error="errors.fini" class="mr-2 w-full " :label="__('Date Start')" />
              <text-input type="date" v-model="form.fend" :error="errors.fend" class="mr-2 w-full" :label="__('Date End')" />
   
              <select-input v-if="!(hidden_fields && hidden_fields.includes('ticket_type'))" v-model="form.type_id" class="mr-2 w-full mt-[23px]">
                  <option :value="null">{{ __('Type') }}</option>
                  <option v-for="s in types" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select-input>

              <select-input v-if="!(hidden_fields && hidden_fields.includes('department'))"  v-model="form.department_id" class="mr-2 w-full mt-[23px]">
                  <option :value="null">{{ __('Department') }}</option>
                  <option v-for="s in departments" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select-input>

              <select-input v-if="!(hidden_fields && hidden_fields.includes('category'))" v-model="form.category_id" class="mr-2 w-full mt-[23px]">
                  <option :value="null">{{ __('Category') }}</option>
                  <option v-for="s in categories" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select-input>
              
              <select-input v-model="form.priority_id" class=" mr-2 w-full mt-[23px]">
                  <option :value="null">{{ __('Priority') }}</option>
                  <option v-for="s in priorities" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select-input>
              <select-input v-model="form.status_id" class="mr-2 w-full mt-[23px]">
                  <option :value="null">{{ __('Status') }}</option>
                  <option v-for="s in statuses" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select-input>
              <select-input-filter :placeholder="__('Assign To')" :onInput="doFilter" @focus="doFilter" :items="assignees"
                                   v-if="!(hidden_fields && hidden_fields.includes('assigned_to'))"
                                   v-model="form.assigned_to" class=" w-full mt-[23px]">
              </select-input-filter>
          </div>
  
          
        <div class="badge__items flex flex-col lg:flex-row gap-5">
            <div class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" @click="goToLink(this.route('tickets', {'type': 'new'}))">
                <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                    <div class="badge__info">
                        <span class="title">{{ __('New Tickets') }}</span>
                        <span class="number">{{ new_tickets }}</span>
                    </div>
                    <div class="a__right">
                        <div class="round_circle pr-3 rtl:pl-3">
                            <div class="pie animate" :style="{ '--pie_val': parseInt((new_tickets * 100)/total_tickets) }"> {{ parseInt((new_tickets * 100)/total_tickets) || 0 }}%</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" @click="goToLink(this.route('tickets', {'type': 'open'}))">
                <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                    <div class="badge__info">
                        <span class="title">{{ __('Open Tickets') }}</span>
                        <span class="number">{{ opened_tickets }}</span>
                    </div>
                    <div class="a__right">
                        <div class="round_circle pr-3 rtl:pl-3">
                            <div class="pie animate" :style="{ '--pie_val': parseInt((opened_tickets * 100)/total_tickets) }"> {{ parseInt((opened_tickets * 100)/total_tickets) || 0 }}%</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" @click="goToLink(this.route('tickets', {'search': 'close'}))">
                <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                    <div class="badge__info">
                        <span class="title">{{ __('Closed Tickets') }}</span>
                        <span class="number">{{ closed_tickets }}</span>
                    </div>
                    <div class="a__right">
                        <div class="round_circle pr-3 rtl:pl-3">
                            <div class="pie animate" :style="{ '--pie_val': parseInt((closed_tickets * 100)/total_tickets) }"> {{ parseInt((closed_tickets * 100)/total_tickets) || 0 }}%</div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="auth.user.role.slug !== 'customer'" class="badge__item h-32 w-full lg:w-1/4 cursor-pointer" @click="goToLink(this.route('tickets', {'type': 'un_assigned'}))">
                <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                    <div class="badge__info">
                        <span class="title">{{ __('Unassigned Tickets') }}</span>
                        <span class="number">{{ un_assigned_tickets }}</span>
                    </div>
                    <div class="a__right">
                        <div class="round_circle pr-3 rtl:pl-3">
                            <div class="pie animate" :style="{ '--pie_val': parseInt((un_assigned_tickets * 100)/total_tickets) }"> {{ parseInt((un_assigned_tickets * 100)/total_tickets) || 0 }}%</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="response__details mt-8 flex gap-5 flex-col lg:flex-row" v-if="auth.user.role.slug !== 'customer'">
            <div class="w-full">
                <div class="r__wrapper flex flex-col pl-5 pr-5 pb-5 bg-white items-center rounded-lg shadow-lg rd">
                    <h2 class="th__ttl font-bold text-lg pt-3">{{ __('Ticket by department') }}</h2>
                    <div class="th__info flex flex-col pt-3">
                        <vc-donut
                            background="white" foreground="grey"
                            :size="120" unit="px" :thickness="45"
                            has-legend legend-placement="right"
                            :sections="top_departments" :total="100"
                            :start-angle="0" :auto-adjust-text-size="true">
                        </vc-donut>
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="r__wrapper flex flex-col pl-5 pr-5 pb-5 bg-white items-center rounded-lg shadow-lg rd">
                    <h2 class="th__ttl font-bold text-lg pt-3">{{ __('Ticket by type') }}</h2>
                    <div class="th__info flex flex-col pt-3">
                        <vc-donut
                            background="white" foreground="grey"
                            :size="120" unit="px" :thickness="45"
                            has-legend legend-placement="right"
                            :sections="top_types" :total="100"
                            :start-angle="0" :auto-adjust-text-size="true">
                        </vc-donut>
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="r__wrapper flex flex-col pl-5 pl-5 pb-5 bg-white items-center rounded-lg shadow-lg rd">
                    <h2 class="th__ttl font-bold text-lg pt-3">{{ __('Top ticket creator') }}</h2>
                    <div class="th__info flex flex-col pt-3">
                        <vc-donut
                            background="white" foreground="grey"
                            :size="120" unit="px" :thickness="45"
                            has-legend legend-placement="right"
                            :sections="top_creators" :total="100"
                            :start-angle="0" :auto-adjust-text-size="true">
                        </vc-donut>
                    </div>
                </div>
            </div>
        </div>  
        <div class="response__details flex flex-col lg:flex-row mt-8 gap-5" v-if="auth.user.role.slug !== 'customer'">
            <div class="flex gap-5 flex-col lg:flex-row lg:w-10/12">
                <div class="w-full">
                    <div class="r__wrapper flex flex-col p-5 bg-white rounded-lg shadow-lg rd">
                        <h2 class="th__ttl font-bold text-lg pt-3">{{ __('Ticket history created') }}</h2>
                        <div class="th__info flex">
                            <span class="text-2xl font-bold"> {{ chart_line.this_month }} </span>
                            <span class="pt-2 text-xs pl-1 pr-1">/ {{ __('this month') }}</span>
                            <span class="pt-2 text-xs font-bold pl-2 pr-2">{{ __('last month') }} {{ chart_line.last_month }}</span>
                        </div>
                        <div v-if="months.length" class="flex w-full justify-center c__wrapper ">
                            <div class="c__line flex flex-col w-full items-center gap-3" v-for="cl in months">
                                <span class="cl__b" :style="{ '--cl_value': cl.value }"></span>
                                <span class="cl__n text-xs">{{ cl.month }} <b v-if="cl.number">({{ cl.number}})</b></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class=" rd w-full lg:w-2/5">
                    <div class="r__wrapper flex flex-col pl-5 pr-5 pb-5 bg-white rounded-lg shadow-lg rd">
                        <div class="res__info">
                            <span class="title">{{ __('First Response Time') }}</span>
                            <span class="res_avg">{{ __('Average') }}</span>
                            <div class="flex justify-start">
                                <div v-if="firstResponse.length" v-for="(fr, fri) in firstResponse" class="res_time pr-5" :key="fri">
                                    <span class="num">{{ fr[0] }}</span>
                                    <span class="text">{{ __(fr[1]) }}</span>
                                </div>
                                <div v-else class="res_time pr-5">
                                    0
                                </div>
                            </div>
                        </div>
                        <div class="tc__info">
                            <span class="title">{{ __('Last Response Time') }}</span>
                            <span class="res_avg">{{ __('Average') }}</span>
                            <div class="flex justify-start">
                                <div v-if="lastResponse.length" v-for="(fr, fri) in lastResponse" class="res_time pr-5" :key="fri">
                                    <span class="num">{{ fr[0] }}</span>
                                    <span class="text">{{ __(fr[1]) }}</span>
                                </div>
                                <div v-else class="res_time pr-5">
                                    0
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex gap-5 flex-col lg:w-2/12">
                <div class="badge__item h-32 w-full cursor-pointer" @click="goToLink(this.route('users'))">
                    <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                        <div class="badge__info">
                            <span class="title">{{ __('Customers') }}</span>
                            <span class="number">{{ total_customer }}</span>
                        </div>
                        <div class="a__right">
                            <icon name="pending_users" class="h-5 fill-gray-400 mr-5 ml-5" />
                        </div>
                    </div>
                </div>
                <div class="badge__item h-32 w-full cursor-pointer" @click="goToLink(this.route('contacts'))">
                    <div class="l__items bg-white rounded-lg shadow-lg flex justify-between w-full">
                        <div class="badge__info">
                            <span class="title">{{ __('Contacts') }}</span>
                            <span class="number">{{ total_contacts }}</span>
                        </div>
                        <div class="a__right">
                            <icon name="contact" class="h-5 fill-gray-400 mr-5 ml-5" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Loading Process -->
        <div v-if="loading" class="processing-overlay">
            <div class="background"></div>
            <div class="loader">
                <svg width="200px" height="200px"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="background: none;">
                    <circle cx="75" cy="50" fill="#ffffff" r="6.39718">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.875s"></animate>
                    </circle>
                    <circle cx="67.678" cy="67.678" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
                    </circle>
                    <circle cx="50" cy="75" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.625s"></animate>
                    </circle>
                    <circle cx="32.322" cy="67.678" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
                    </circle>
                    <circle cx="25" cy="50" fill="#ffffff" r="4.8">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.375s"></animate>
                    </circle>
                    <circle cx="32.322" cy="32.322" fill="#ffffff" r="4.80282">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
                    </circle>
                    <circle cx="50" cy="25" fill="#ffffff" r="6.40282">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.125s"></animate>
                    </circle>
                    <circle cx="67.678" cy="32.322" fill="#ffffff" r="7.99718">
                        <animate attributeName="r" values="4.8;4.8;8;4.8;4.8" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
                    </circle>
                </svg>
            </div>
        </div>
        <!-- Loading Process -->
  
    </div>
  </template>
  
  <script>
  import {Head, Link} from '@inertiajs/inertia-vue3'
  import Layout from '@/Shared/Layout'
  import Icon from '@/Shared/Icon'
  import TextInput from '@/Shared/TextInput'
  import SelectInput from '@/Shared/SelectInput'
  import SearchInput from '@/Shared/SearchInput'
  import SelectInputFilter from '@/Shared/SelectInputFilter'
  import throttle from 'lodash/throttle'
  import pickBy from 'lodash/pickBy' 
  
  export default {
    metaInfo: { title: 'Dashboard' },
      components: {
          SearchInput,
          Icon,
          Link,
          Head,
          TextInput,
          SelectInputFilter,
          SelectInput,
      },
    layout: Layout,
      props: { 
          fini: null,
          fend: null,
          auth: Object,
          entries: Array,
          chart_line: Object,
          api_key: String,
          new_tickets: Number,
          total_tickets: Number,
          un_assigned_tickets: Number,
          opened_tickets: Number,
          closed_tickets: Number,
          first_response: Array,
          top_creators: Array,
          last_response: Array,
          top_departments: Array,
          top_types: Array,
          total_customer: Number,
          total_contacts: Number,
          priorities: Array,
          statuses: Array,
          types: Array,
          categories: Array,
          departments: Array,
          hidden_fields: Object,
          assignees: Array,
          filters: Object,
      },
      data() {
          return {
              headers: [
                  {name: 'Key', value: 'uid', sort: true},
                  {name: 'Subject', value: 'subject', sort: true},
                  {name: 'Priority', value: 'priority_id', sort: true},
                  {name: 'Status', value: 'status_id', sort: true},
                  {name: 'Date', value: 'created_at', sort: true},
                  {name: 'Updated', value: 'updated_at', sort: true},
              ],
              user_access: this.$page.props.auth.user.access,
              form: {
                  fini: this.filters.fini,
                  fend: this.filters.fend,
                  search: this.filters.search,
                  customer_id: this.filters.customer_id,
                  field: this.filters.field,
                  direction: this.filters.direction,
                  priority_id: this.filters.priority_id ?? null,
                  status_id: this.filters.status_id ?? null,
                  type_id: this.filters.type_id ?? null,
                  category_id: this.filters.category_id ?? null,
                  department_id: this.filters.department_id ?? null,
              },
          
              errors: [],
              loading: false,
              firstResponse: [],
              lastResponse: [],
              months: []
          }
      },
      updated(){

        this.firstResponse = [];
        this.lastResponse = [];

         for (let i = 0; i < this.first_response.length; i++) {
              if(i % 2 === 0){
                  this.firstResponse = [...this.firstResponse, [this.first_response[i], this.first_response[i+1]]]
              }
          }
          for (let i = 0; i < this.last_response.length; i++) {
              if(i % 2 === 0){
                  this.lastResponse = [...this.lastResponse, [this.last_response[i], this.last_response[i+1]]]
              }
          }
  
          this.months = this.chart_line.previousMonths.map( m =>{
              return { 'month': m, number : this.chart_line.months[m] ,  'value': this.chart_line.months[m] ? ((this.chart_line.months[m] * 100)/this.chart_line.total)+'%': '0%' }
          })
      },
      created() {

        

          for (let i = 0; i < this.first_response.length; i++) {
              if(i % 2 === 0){
                  this.firstResponse = [...this.firstResponse, [this.first_response[i], this.first_response[i+1]]]
              }
          }
          for (let i = 0; i < this.last_response.length; i++) {
              if(i % 2 === 0){
                  this.lastResponse = [...this.lastResponse, [this.last_response[i], this.last_response[i+1]]]
              }
          }
  
          this.months = this.chart_line.previousMonths.map( m =>{
              return { 'month': m, number : this.chart_line.months[m] ,  'value': this.chart_line.months[m] ? ((this.chart_line.months[m] * 100)/this.chart_line.total)+'%': '0%' }
          })
      },
      watch: {
          form: {
              deep: true,
              handler: throttle(function() {
                   
                  this.$inertia.get(this.route('dashboard'), pickBy(this.form), { replace: true, preserveState: true })
              }, 150),
          },
      },
      methods: {
          update(){

          },  
          doFilter(e){
              this.axios.get(this.route('filter.assignees', {search: e.target.value})).then((res)=>{
                  this.assignees.splice(0, this.assignees.length, ...res.data);
              })
          },
          doFilterCategories(e){
            this.axios.get(this.route('filter.get_category_by_departament', {search: e.target.value})).then((res)=>{
                this.categories.splice(0, this.categories.length, ...res.data);
            })
          },
          sort(field) {
              this.form.field = field;
              this.form.direction = this.form.direction === 'asc' ? 'desc' : 'asc';
          },
          reset() {
              this.form = mapValues(this.form, () => null)
          },
          goToLink(link){
              window.location.href = link;
          },
      },
  }
  </script>
  